var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-wrapper" }, [
    _c(
      "svg",
      {
        staticClass: "input-icon",
        attrs: {
          width: "15",
          height: "16",
          viewBox: "0 0 11 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M10.2143 5.6H9.42857V4C9.42857 1.8 7.66071 0 5.5 0C3.33929 0 1.57143 1.8 1.57143 4V5.6H0.785714C0.353571 5.6 0 5.96 0 6.4V12.8C0 14.56 1.41429 16 3.14286 16H7.85714C9.58571 16 11 14.56 11 12.8V6.4C11 5.96 10.6464 5.6 10.2143 5.6ZM3.14286 4C3.14286 2.68 4.20357 1.6 5.5 1.6C6.79643 1.6 7.85714 2.68 7.85714 4V5.6H3.14286V4ZM7.85714 14.4C8.72143 14.4 9.42857 13.68 9.42857 12.8V7.2H1.57143V12.8C1.57143 13.68 2.27857 14.4 3.14286 14.4H7.85714Z",
            fill: "#6F96D7"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("input", {
      staticClass: "input",
      class: _vm.className,
      attrs: { type: _vm.typeRender, placeholder: "Password" },
      on: {
        input: function($event) {
          return _vm.changeValue($event)
        }
      }
    }),
    _vm._v(" "),
    _c("button", {
      staticClass: "form-element-eye",
      attrs: { type: "button" },
      on: {
        click: function($event) {
          return _vm.toggleSymbols()
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }